/**
 * @module lineheight/lineheight
 */

import { Plugin } from 'ckeditor5/src/core';

import LineHeightEditing from './lineheight/lineheightediting';
import LineHeightUI from './lineheight/lineheightui';

/**
 * The line height plugin.
 *
 * @extends Plugin
 */
export default class LineHeight extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ LineHeightEditing, LineHeightUI ];
	}

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'LineHeight';
	}
}
